import { restApi } from '../../api/restApiSlice';
import { RenderProofResponse } from './RenderProofResponse';

const renderProofApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getRenderProof: builder.query<RenderProofResponse, { domain: string }>({
      query: ({ domain }) => ({
        url: '/v3/render-proof',
        method: 'GET',
        params: { domain },
      }),
    }),
  }),
});

export { renderProofApi };
export const { useGetRenderProofQuery } = renderProofApi;
